<template>
  <el-col :lg="8" :md="12" :sm="24" class="card">
      <el-card>
        <div class="clearfix" slot="header">
          <app-i18n code="entities.price.menu"></app-i18n>
          <el-button @click="onClickAdd()" icon="el-icon-fa-plus" type="primary"></el-button>
        </div>
        <div :key="price.id" v-for="price in rows" class="category-name">
          <span>{{price.amount}} {{price.currency.toUpperCase()}}</span>
          <div>
            <el-button @click="onClickEdit(price)" icon="el-icon-fa-edit" type="text"></el-button>
            <el-button :disabled="destroyLoading" @click="doDestroyWithConfirm(price.id)" icon="el-icon-fa-trash" type="text" v-if="hasPermissionToDestroy"></el-button>
          </div>
        </div>

        <div class="el-pagination-wrapper">
          <el-pagination
            :current-page="pagination.currentPage || 1"
            :disabled="loading"
            :layout="paginationLayout"
            :total="count"
            @current-change="doChangePaginationCurrentPage"
            @size-change="doChangePaginationPageSize"
          ></el-pagination>
        </div>
      </el-card>

    <el-dialog :visible.sync="dialogFormVisible" :title="titleModal()">
      <!--Form Create Price -->
      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="12" :md="20" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.amount.label"
          :prop="fields.amount.name"
          :required="fields.amount.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model.number="model[fields.amount.name]" ref="focus" ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.currency.label"
          :prop="fields.currency.name"
          :required="fields.currency.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-select placeholder v-model="model[fields.currency.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.currency.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>

      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="dialogFormVisible=false"> <app-i18n code="common.cancel"></app-i18n></el-button>
        <el-button @click="doSubmit" icon="el-icon-fa-floppy-o" type="primary">
          <app-i18n code="common.save"></app-i18n>
        </el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { PriceModel } from '@modules/price/price-model';
import { mapGetters, mapActions } from 'vuex';
import { PricePermissions } from '@modules/price/price-permissions';
import { i18n } from '@shared/i18n';
import { FormSchema } from '@shared/form/form-schema';

const { fields } = PriceModel;
const formSchema = new FormSchema([fields.id, fields.currency, fields.amount]);

export default {
  name: 'app-price-list-card',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      dialogFormVisible: false,
    };
  },

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'price/list/rows',
      count: 'price/list/count',
      loading: 'price/list/loading',
      pagination: 'price/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'price/destroy/loading',
      paginationLayout: 'layout/paginationLayout',

      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'price/form/record',
      findLoading: 'price/form/findLoading',
      saveLoading: 'price/form/saveLoading',
    }),

    hasPermissionToCreate() {
      return new PricePermissions(this.currentUser).create;
    },

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new PricePermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new PricePermissions(this.currentUser).destroy;
    },

    isEditing() {
      return !(this.model.id == null);
    },

    fields() {
      return fields;
    },
  },

  async created() {
    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doChangeSort: 'price/list/doChangeSort',
      doChangePaginationCurrentPage:
        'price/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'price/list/doChangePaginationPageSize',
      doMountTable: 'price/list/doMountTable',
      doDestroy: 'price/destroy/doDestroy',
      doUpdate: 'price/form/doUpdate',
      doCreate: 'price/form/doCreate',
    }),

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);
      this.dialogFormVisible = false;

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {

        return this.doCreate(values);
      }
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        //Error
      }
    },

    titleModal() {
      var title = ""
      if (this.isEditing) {
        title = i18n('entities.price.edit.title')
        return title
      } else {
        title = i18n('entities.price.new.title')
        return title
      }
    },

    onClickEdit(price) {
      this.dialogFormVisible = true;
      // Corregido! con el formSchema decides los atributos del modelo que se quieren guardar
      this.model = formSchema.initialValues(price);
    },
    onClickAdd() {
      this.dialogFormVisible = true;
      this.model = formSchema.initialValues(null);
    },
  },
};
</script>

<style>
</style>
